import {
  LIST_DIAGNOSTICS_REQUEST,
  LIST_DIAGNOSTICS_SUCCESS,
  LIST_DIAGNOSTICS_ERROR,
  GET_DIAGNOSTIC_REQUEST,
  GET_DIAGNOSTIC_SUCCESS,
  GET_DIAGNOSTIC_ERROR,
  ADD_DIAGNOSTIC_REQUEST,
  ADD_DIAGNOSTIC_SUCCESS,
  ADD_DIAGNOSTIC_ERROR,
  EDIT_DIAGNOSTIC_REQUEST,
  EDIT_DIAGNOSTIC_SUCCESS,
  DELETE_DIAGNOSTIC_REQUEST,
  DELETE_DIAGNOSTIC_SUCCESS,
  DELETE_DIAGNOSTIC_ERROR,
  LINK_DIAGNOSTIC_SUBJECTS_REQUEST,
  LINK_DIAGNOSTIC_SUBJECTS_SUCCESS,
  LINK_DIAGNOSTIC_SUBJECTS_ERROR,
  GET_DIAGNOSTIC_SUBJECTS_REQUEST,
  GET_DIAGNOSTIC_SUBJECTS_SUCCESS,
  GET_DIAGNOSTIC_SUBJECTS_ERROR,
  RESET_STATE_ALL_APPLICATION,
  RESET_STATE_REDUX,
} from '../actions';

const INIT_STATE = {
  currentDiagnostic: null,
  currentDiagnosticsList: null,
  currentDiagnosticSubjects: null,
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return { ...state, error: '', currentDiagnostic: null, success: '' };

    case LIST_DIAGNOSTICS_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_DIAGNOSTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDiagnosticsList: action.payload,
        error: '',
      };
    case LIST_DIAGNOSTICS_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case GET_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '' };
    case GET_DIAGNOSTIC_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDiagnostic: action.payload,
        error: '',
      };
    case GET_DIAGNOSTIC_ERROR:
      return {
        ...state,
        loading: false,
        currentDiagnostic: null,
        error: action.payload.message,
      };

    case ADD_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case ADD_DIAGNOSTIC_SUCCESS: {
      const list = state.currentDiagnosticsList
        ? [...state.currentDiagnosticsList, action.payload]
        : [action.payload];
      return {
        ...state,
        loading: false,
        currentDiagnosticsList: list,
        currentDiagnostic: action.payload,
        success: action.payload,
        error: '',
      };
    }
    case ADD_DIAGNOSTIC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };

    case EDIT_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case EDIT_DIAGNOSTIC_SUCCESS: {
      const updated = (state.currentDiagnosticsList ?? []).map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
      return {
        ...state,
        loading: false,
        currentDiagnosticsList: updated,
        success: action.payload,
        error: '',
      };
    }

    case DELETE_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case DELETE_DIAGNOSTIC_SUCCESS: {
      const filtered = (state.currentDiagnosticsList ?? []).filter(
        (diagnostic) => diagnostic.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        currentDiagnosticsList: filtered,
        success: { deleted: true },
        error: '',
      };
    }
    case DELETE_DIAGNOSTIC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };

    case LINK_DIAGNOSTIC_SUBJECTS_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case LINK_DIAGNOSTIC_SUBJECTS_SUCCESS:
      return { ...state, loading: false, success: { linked: true }, error: '' };
    case LINK_DIAGNOSTIC_SUBJECTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };

    case GET_DIAGNOSTIC_SUBJECTS_REQUEST:
      return { ...state, loading: true, error: '' };
    case GET_DIAGNOSTIC_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDiagnosticSubjects: action.payload,
        error: '',
      };
    case GET_DIAGNOSTIC_SUBJECTS_ERROR:
      return {
        ...state,
        loading: false,
        currentDiagnosticSubjects: null,
        error: action.payload.message,
      };

    default:
      return { ...state };
  }
};
